import { FunctionComponent, useMemo } from 'react';
import { Moment } from 'moment-timezone';
import styles from './DailyBoarding.module.scss';

export interface DailyBoardingProps {
    date: Moment;
    bookingsCount: number;
    occupancyPercentage: number;
    assignedUnitsTotal: number;
    unassignedUnitsTotal: number;
}

export const DailyBoarding: FunctionComponent<DailyBoardingProps> = ({
    date,
    bookingsCount,
    occupancyPercentage,
    assignedUnitsTotal,
    unassignedUnitsTotal
}) => {
    const dateLabel = useMemo(() => date.clone().format('MMM D'), [date]);

    const bookedLabel = bookingsCount === 1 ? '1 Booked' : `${bookingsCount} Booked`;

    const fillPercent = Math.min(100, Math.max(0, occupancyPercentage));

    return (
        <article className={styles.card}>
            <div className={styles.topRow}>
                <span className={styles.date}>{dateLabel}</span>
                <span className={styles.booked}>{bookedLabel}</span>
            </div>
            <div
                className={styles.progressTrack}
                role="presentation"
            >
                <div
                    className={styles.progressFill}
                    style={{ width: `${fillPercent}%` }}
                />
            </div>
            <div className={styles.stats}>
                <div className={styles.statLine}>
                    Assigned: <span className={styles.statValue}>{assignedUnitsTotal}</span>
                </div>
                <div className={styles.statLine}>
                    Unassigned: <span className={styles.statValue}>{unassignedUnitsTotal}</span>
                </div>
            </div>
        </article>
    );
};
